import React, { Component } from 'react';

//componentes
import PagosAprobados from './pagosAprobados'

class Index extends Component {

    render(){
        return(
            <div>
                <PagosAprobados />
            </div>
        );
    }

}
export default Index;